/**
 * Created by fers on 05.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import config from '../../common/config';
import types from '../../common/model-api/types';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import * as Tool from '../fw/Tool';
import {injectIntl, IntlShape} from 'react-intl';
import {channelDefState} from '../../common/model-api/ChannelDefType';
import {sortRules} from '../../common/model-api/ScenarioChannelDefRuleType';

import './Scenario.scss';
import { Scenario } from '../../common/types/types';

export const DEFAULT_SIZE = 'default';
export const MEDIUM_SIZE = 'medium';
export const SMALL_SIZE = 'small';

interface ScenarioIconProps {
    intl?: object;
    isFlow?: boolean;
    payPlan?: string;
    scenario?: Scenario;
    size?: unknown | unknown | unknown;
    state?: string;
}

class ScenarioIcon extends React.Component<ScenarioIconProps> {

    static propTypes = {
        intl: PropTypes.object,
		isFlow: PropTypes.bool,
        payPlan: PropTypes.string,
        scenario: PropTypes.object,
		size: PropTypes.oneOf([DEFAULT_SIZE, MEDIUM_SIZE, SMALL_SIZE]),
        state: PropTypes.string,
    };

	static defaultProps = {
		size: DEFAULT_SIZE
	};

	getSortedChannels(isFlow) {
		return this.props.scenario.scenarios2ChannelDefs.edges.map(({node}) => node).filter((s2cd) => s2cd.doNotShowToUser ? false : true).sort(sortRules);
	}

    render() {
        let {scenario, state, payPlan, size} = this.props;

        if (!scenario) {
            return (<div className={"scenarioGridList-icons count-2 size-" + size + (this.props.isFlow ? ' type-flow' : '')}>
				<div className="minorIcons">
					<div className="minorIcon">
						<span className="fa fa-desktop"> </span>
					</div>
					<div className="minorIcon">
						<span className="fa fa-desktop"> </span>
					</div>
				</div>
			</div>);
        }

		let isFlow = this.props.isFlow || (scenario && scenario.scenarioDef && scenario.scenarioDef.scenarioFlowDefs ? scenario.scenarioDef.scenarioFlowDefs.edges.length > 0 : false);
		let sortChannels = this.getSortedChannels(isFlow);
		let mainIcon = null;
		let minorIcons = [];

		sortChannels.forEach((item, idx) => {
            if (!item.channelDef) {
                return;
            }

			if (item.ruleType === "destination" && !isFlow) {
				mainIcon = (<ChannelIcon channelDef={item.channelDef} key={idx} noDimensions size={78} />);
				return;
			}

			minorIcons.push(<div className="minorIcon" key={idx}><ChannelIcon channelDef={item.channelDef} size={54}/></div>);
		});
		minorIcons = minorIcons.slice(0, 4);

		if (!mainIcon && minorIcons.length === 0) {
            mainIcon = (<ChannelIcon channelDef={{
                    icon: "dativery",
                    name: config.PRODUCT_NAME
                }} key={0} noDimensions size={78} />);
        }

        if (state && channelDefState[state] && channelDefState[state]['hide']) {
            state = null;
        }

        if (!mainIcon && minorIcons.length === 1) {
            mainIcon = minorIcons[0];
            minorIcons = [];
        }

        return (
			<div className={"scenarioGridList-icons" + " count-" + minorIcons.length + (isFlow ? " type-flow" : '') + " size-" + size}>
				{mainIcon && !isFlow ? <div className="mainIcon">{mainIcon}</div> : null }
                {mainIcon && isFlow ? <div className="minorIcons">{mainIcon}</div> : null}
				{minorIcons.length ? <div className="minorIcons">{minorIcons}</div> : null}
                {state ? <div className={"state badge " + state.toLowerCase()}>{Tool.tranformDataForView('scenarios', Tool.getMappingForColumn('state', types['scenarios'].fields()), this.props.intl.formatMessage, state, true)}</div> : null}
                {payPlan ? <div className={"payPlan badge " + payPlan.toLowerCase()}>{Tool.tranformDataForView('scenarios', Tool.getMappingForColumn('requiredPayPlan', types['scenarios'].fields()), this.props.intl.formatMessage, payPlan, true)}</div> : null}
			</div>
        );
    }
}

export let RawScenarioIcon = injectIntl(ScenarioIcon);

export default Relay.createContainer(RawScenarioIcon, {
    fragments: {
        scenario: () => Relay.QL`
            fragment on Scenario {
                id,
                name,
				scenarioDef {
					scenarioFlowDefs (first: 1) {
	                    edges {
	                        node {
								name
							}
						}
					}
				},
                scenarios2ChannelDefs(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            ruleType,
							order,
                            doNotShowToUser,
                            channelDef {
                                id,
                                name,
                                icon
                            }
                        }
                    }
                }
            }
        `,
    },
});
